export const common = {
  'site.name': 'CSSBuy Spreadsheet',
  'site.domain': 'cssbuybr.wtf',
  'nav.home': 'Home',
  'nav.spreadsheet': 'Spreadsheet',
  'nav.guides': 'Guides',
  'nav.reviews': 'Reviews',
  'nav.shipping': 'Shipping',
  'nav.coupons': 'Coupons',
  'nav.safety': 'Safety',
  'nav.about': 'About',
  'nav.contact': 'Contact',
  'nav.shoppingGuide': 'Shopping Guide',
  'nav.products': 'Products',
  'lang.en': 'EN',
  'lang.pt': 'PT-BR',
  'lang.de': 'DE',
  'cta.explore': 'Explore CSSBuy Spreadsheet',
  'cta.startGuide': 'Start Beginner Guide',
  'cta.readMore': 'Read More',
  'cta.viewAll': 'View All',
  'cta.buyNow': 'Buy It Now',
  'cta.cssbuySpreadsheet': 'CSSBuy Spreadsheet',
  'cta.continueMain': 'Continue to Main Website',
  'footer.disclaimer': 'This website is an independent informational resource and is not affiliated with or endorsed by CSSBuy. Information may change. Always verify current prices, availability, shipping conditions, policies and applicable laws before purchasing.',
  'footer.copyright': '© {year} CSSBuy Spreadsheet Guide. All rights reserved.',
  'footer.links': 'Quick Links',
  'footer.legal': 'Legal',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  'footer.editorial': 'Editorial Policy',
  'footer.sitemap': 'Sitemap',
  'hero.eyebrow': 'CSSBUY SPREADSHEET • INDEPENDENT GUIDE',
  'hero.h1': 'CSSBuy Spreadsheet — Find, Compare & Research Products',
  'hero.description': 'Explore the CSSBuy Spreadsheet, buying guides, shipping info, QC, warehouse, reviews & comparisons all in one place.',
  'hero.secondary': 'Our goal is to help you research products, understand costs, and make more informed decisions before buying.',
  'hero.trust': 'Independent Guide • Updated Content • English, Português & Deutsch • Safety Focus',
  'spreadsheet.h2': 'CSSBuy Spreadsheet: Your Starting Point for Product Research',
  'spreadsheet.description': 'The CSSBuy Spreadsheet organizes information and links to make product research easier. Use it as a starting point and always confirm current prices, availability, sellers, and conditions before buying.',
  'spreadsheet.card1.title': 'Find',
  'spreadsheet.card1.desc': 'Discover products and categories.',
  'spreadsheet.card2.title': 'Compare',
  'spreadsheet.card2.desc': 'Compare information before deciding.',
  'spreadsheet.card3.title': 'Verify',
  'spreadsheet.card3.desc': 'Check links, sellers, and QC when available.',
  'spreadsheet.card4.title': 'Decide',
  'spreadsheet.card4.desc': 'Confirm current information before payment.',
  'spreadsheet.cta': 'View CSSBuy Spreadsheet',
  'categories.h2': 'Explore CSSBuy Spreadsheet by Category',
  'categories.cta': 'View All Categories',
  'beginner.h2': 'Never Used CSSBuy? Start Here',
  'beginner.step1': 'Find — discover products.',
  'beginner.step2': 'Research — compare prices and information.',
  'beginner.step3': 'Verify — analyze QC, policies, and costs.',
  'beginner.step4': 'Decide — confirm everything before payment.',
  'beginner.cta': 'Read Beginner Guide',
  'review.h2': 'CSSBuy Review: Is It Worth It?',
  'review.description': 'Analyze features, costs, shipping, warehouse, QC, advantages, limitations, and safety points before deciding.',
  'review.card1': 'CSSBuy Review',
  'review.card2': 'CSSBuy Shipping Cost',
  'review.card3': 'CSSBuy Warehouse',
  'review.card4': 'Is CSSBuy Legit?',
  'review.card5': 'CSSBuy Coupon',
  'review.card6': 'CSSBuy Discount Code',
  'review.cta': 'View All Reviews',
  'shipping.h2': 'CSSBuy Shipping Cost: Understand the Costs',
  'shipping.desc': 'Weight, volume, destination, shipping line, insurance, and additional services can affect the final price.',
  'shipping.table.factor': 'Factor',
  'shipping.table.impact': 'Impact',
  'shipping.weight': 'Weight',
  'shipping.weightImpact': 'Can increase cost',
  'shipping.volume': 'Volume',
  'shipping.volumeImpact': 'May affect certain routes',
  'shipping.destination': 'Destination',
  'shipping.destinationImpact': 'Values vary by country',
  'shipping.line': 'Line',
  'shipping.lineImpact': 'Rates vary',
  'shipping.insurance': 'Insurance',
  'shipping.insuranceImpact': 'May change value',
  'shipping.services': 'Services',
  'shipping.servicesImpact': 'May generate additional costs',
  'shipping.cta': 'View Shipping Cost Guide',
  'safety.h2': 'Safety First',
  'safety.card1': 'Verify links',
  'safety.card2': 'Protect account',
  'safety.card3': 'Check final price',
  'safety.card4': 'Analyze QC',
  'safety.card5': 'Understand shipping',
  'safety.card6': 'Check customs rules',
  'safety.card7': 'Avoid suspicious sites',
  'safety.card8': 'Do not share sensitive data',
  'safety.cta': 'Visit Safety Center',
  'trust.h2': 'Why Use Our Guide?',
  'trust.point1': 'Organized information',
  'trust.point2': 'Updated content',
  'trust.point3': 'Comparisons',
  'trust.point4': 'Multilingual',
  'trust.point5': 'Independent',
  'final.h2': 'Ready to Explore CSSBuy Spreadsheet?',
  'final.desc': 'Start with our main guide and find resources to research products, understand costs, and buy with more information.',
  'final.cta': 'Explore CSSBuy Spreadsheet',
  'dropdown.label': 'Categories',
  'pillar.h2': 'CSSBuy Guides & Resources',
  'pillar.desc': 'Explore our in-depth pillar articles covering reviews, shipping, warehouse, QC, coupons, safety and more.',
  'faq.h2': 'Frequently Asked Questions',
  'faq.q1': 'What is CSSBuy Spreadsheet?',
  'faq.a1': 'The CSSBuy Spreadsheet is an organized collection of product links and information to help you research items before buying. It serves as a starting point for product discovery and comparison.',
  'faq.q2': 'Is CSSBuy safe to use?',
  'faq.a2': 'CSSBuy is a shopping agent service. Like any platform, you should verify current information, check reviews, and follow safety practices before making purchases. Always confirm prices and policies before buying.',
  'faq.q3': 'How do I use CSSBuy Spreadsheet?',
  'faq.a3': 'Use the spreadsheet to browse categories, find products that interest you, and compare information. Always verify current links, seller information, and prices directly on the platform before purchasing.',
  'faq.q4': 'What are CSSBuy shipping costs?',
  'faq.a4': 'Shipping costs depend on weight, volume, destination, shipping line, and additional services. Check our shipping guide for detailed information on factors that affect pricing.',
  'faq.q5': 'How do I find CSSBuy coupons?',
  'faq.a5': 'Coupon availability changes frequently. Always check current promotions on the official platform or our coupon guide for the latest verified information.',
  'article.readTime': '{minutes} min read',
  'article.lastUpdated': 'Last updated: {date}',
  'article.author': 'CSSBuy Guide Team',
  'article.breadcrumbHome': 'Home',
  'article.relatedArticles': 'Related Articles',
  'article.toc': 'Table of Contents',
  'article.quickAnswer': 'Quick Answer',
  'article.safetyNote': 'Always verify the current platform, payment page, seller information, prices, shipping conditions and applicable laws before purchasing.',
  'article.sources': 'Sources & Verification',
  'seo.keywords': 'CSSBuy spreadsheet, CSSBuy review, CSSBuy shipping cost, CSSBuy coupon, CSSBuy guide',
  'seo.metaDescription': 'CSSBuy Spreadsheet guide — find, compare and research products. Independent reviews, shipping costs, warehouse info, QC guides, coupons and safety tips.',
  'seo.title': 'CSSBuy Spreadsheet — Find, Compare & Research Products | cssbuybr.wtf',
  'category.shoes': 'Shoes',
  'category.hoodies': 'Hoodies/Sweaters',
  'category.tshirts': 'T-Shirts',
  'category.jackets': 'Jackets',
  'category.pants': 'Pants/Shorts',
  'category.headwear': 'Headwear',
  'category.sets': 'Sets',
  'category.underwear': 'Underwear/Underpants',
  'category.jersey': 'Jersey',
  'category.accessories': 'Accessories',
  'category.bags': 'Bags',
  'category.belts': 'Belts',
  'category.perfumes': 'Perfumes',
  'category.other': 'Other Stuff',
  'featuredProducts': {
    title: 'Featured Products',
    subtitle: 'Browse curated products from the CSSBuy spreadsheet — click any item to view details and purchase on Kaspreadsheet.',
    viewAll: 'View All Products',
  },
  'products': {
    heroTagline: 'Curated Product Selection',
    heroTitle: 'CSSBuy Spreadsheet Products',
    heroSubtitle: 'Browse 100+ verified products from the CSSBuy spreadsheet. Filter by category, compare prices, and click through to purchase.',
    allCategories: 'All Categories',
    allTitle: 'All Products',
    items: 'items',
    noResults: 'No products found in this category.',
    ctaTitle: 'Ready to explore more?',
    ctaSubtitle: 'Visit Kaspreadsheet for the full catalog with thousands more verified products across all categories.',
  },
};

export default common;